import React, {useState} from 'react';
import {Button} from 'antd'
import {useAppDispatch} from "../app/hooks";
import {setMode} from "../features/omikuji/omikujiSlice";

export function Screen1_Agreement(props: any) {
    const dispatch = useAppDispatch();
    return <>
        <p>規約</p>
        <p>・規約規約</p>
        <p>・規約規約</p>
        <p>・規約規約</p>
        <p>・規約規約</p>
        <p>・規約規約</p>
        <Button onClick={()=>dispatch(setMode("mode2_Top"))}> 規約に同意して利用する</Button>
    </>
}
